'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _EntypoIcon = require('../EntypoIcon');

var _EntypoIcon2 = _interopRequireDefault(_EntypoIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var iconClass = 'entypo-svgicon entypo--Onedrive';

var EntypoOnedrive = function EntypoOnedrive(props) {
    return _react2.default.createElement(
        _EntypoIcon2.default,
        _extends({ propClass: iconClass }, props),
        _react2.default.createElement('path', { d: 'M6.429,9.847c0.487-1.961,2.249-3.394,4.341-3.394c1.236,0,2.394,0.505,3.232,1.382c0.354-0.114,0.768-0.202,1.136-0.21v-0.13c0-2.482-1.845-4.495-4.12-4.495C9.392,3,7.998,4.038,7.328,5.531C6.834,5.197,6.257,4.996,5.634,4.996c-1.785,0-3.231,1.577-3.231,3.523c0,0.21,0.024,0.414,0.057,0.613c-1.377,0.136-2.455,1.544-2.455,3.08c0,0.016,0.004,0.029,0.004,0.045C0.008,12.271,0,12.285,0,12.299c0,0.615,0.214,1.177,0.561,1.631C1.053,14.592,1.823,15,2.701,15h1.261c-0.246-0.488-0.398-1.032-0.398-1.615C3.563,11.648,4.794,10.193,6.429,9.847z M17.889,11.777c-0.025,0-0.05,0.007-0.075,0.008c0.007-0.074,0.022-0.146,0.022-0.222c0-1.472-1.193-2.664-2.665-2.664c-0.586,0-1.123,0.194-1.564,0.516c-0.546-1.015-1.604-1.712-2.838-1.712c-1.788,0-3.237,1.449-3.237,3.237c0,0.023,0.006,0.043,0.007,0.066C7.421,10.988,7.303,10.97,7.18,10.97c-1.335,0-2.415,1.081-2.415,2.415c0,0.167,0.017,0.33,0.049,0.487C5.042,15.083,6.102,16,7.38,16h10.706v-0.019C19.158,15.879,20,14.987,20,13.889C20,12.723,19.055,11.777,17.889,11.777z' })
    );
};

exports.default = EntypoOnedrive;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-entypo/lib/entypo/Onedrive.js
// module id = ./node_modules/react-entypo/lib/entypo/Onedrive.js
// module chunks = 2